export const fontSize = (min, max, multiplier = 1) => {
  return `calc(${multiplier} * (${min}px + (${max} - ${min}) * (100vw - 400px) / (1440 - 400)))`;
};
